function turn_on_enquete_calendar(cal_prms){
    $(function () {
        // 非選択日
        var noSelectDays = [];
        if(cal_prms.no_select_days){
            noSelectDays = cal_prms.no_select_days;
        };

        // 日付フォーマット
        var dateFormat = "yy/mm/dd";
        dp_params = {
            language: "ja",
            dateFormat: dateFormat,
            // 非選択日の指定
            beforeShowDay: function (date) {
                var current = $.datepicker.formatDate(dateFormat, date);
                return [noSelectDays.indexOf(current) == -1, "", ""];
            },
        }
        if(cal_prms.min_date){
            dp_params.minDate = cal_prms.min_date;
        }
        if(cal_prms.max_date){
            dp_params.maxDate = cal_prms.max_date;
        }

        $(cal_prms.css_target).datepicker(dp_params);
    });
}

window.turn_on_enquete_calendar = turn_on_enquete_calendar;
